const foldersMutation = {
  setFolders(state, payload) {
    state.folders = payload
  },
}

export default foldersMutation
